/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  customElements.whenDefined('header-component').then(() => {
    const HeaderComponent = customElements.get('header-component');
    
    if (HeaderComponent && HeaderComponent.prototype._sumSplitWidths) {
      
      // 1. Die Phantom-Breiten-Rechnung durch die echte Breite ersetzen
      HeaderComponent.prototype._sumSplitWidths = function(nodes, alignment) {
        let widths = [];
        nodes.forEach((el) => { 
          widths.push(el.clientWidth); 
        });
        
        let [logoWidth, navWidth, iconsWidth] = widths;
        
        if ("left" === alignment) {
          const temp = logoWidth;
          logoWidth = navWidth;
          navWidth = temp;
        }
        
        // Gibt nur noch die tatsächliche Breite zurück
        return logoWidth + navWidth + iconsWidth; 
      };
      
      // 2. Das Theme zwingen, den Cache zu löschen und neu zu rechnen!
      const headerInstance = document.querySelector('header-component');
      if (headerInstance && typeof headerInstance.getMinWidth === 'function') {
        
        window.minWidth = headerInstance.getMinWidth(); 
        
        if (typeof headerInstance.checkWidth === 'function') {
          headerInstance.checkWidth();
        }
      }
    }
  });
})();